
<div class="small-devices">
<div id="main-wrapper">
    <div class="site-wrapper-reveal personalise_content">
        <div class="blog-pages-wrapper section-space--ptb_90">
            <div class="row">
                <div class="col-lg-1"></div>
                <!--====== Blogs Sidecolumns Start ======-->
                <div class="col-lg-4 order-lg-2 order-2">
                    <div class="page-sidebar-content-wrapper page-sidebar-right small-mt__40 tablet-mt__40">
                        <!--====== Blogs Recent Post start ======-->
                        <div
                            class="sidebar-widget blog_sidebarwidget  widgeglobal_section_contentt-blog-recent-post blog_widgetpost wow blog_moveupsidebar move-up">
                            <div class="blog_posttilte sidebar-widget-title global_section_header">Recent Posts</div>
                            <ul class="blog_ulpost">

                                <li class="blog_lipost">
                                    <a href="/postpandamic" class="blog_listanchortags global_section_content">The new
                                        wave of Digital Marketing in the Post-Pandemic world</a>
                                </li>
                                <li class="blog_lipost">
                                    <a href="/migrate-cloud" class="blog_listanchortags global_section_content">Why is
                                        cloud migration critical in the covid-19 scenario</a>
                                </li>
                                <li class="blog_lipost">
                                    <a href="/h1b-visa" class="blog_listanchortags global_section_content">What is H1-B
                                        Visa</a>
                                </li>
                                <li class="blog_lipost">
                                    <a href="/digital-partner" class="blog_listanchortags global_section_content">How to
                                        choose your digital partner?</a>
                                </li>
                                <li class="blog_lipost">
                                    <a href="/cloud-cost-optimization"
                                        class="blog_listanchortags global_section_content">Cloud optimization strategies that drove 50% cost savings</a>
                                </li>
                            </ul>
                        </div>

                        <!--====== Blogs Recent Post end ======-->
                    </div>
                </div>
                <!--====== Blogs Sidecolumns End ======-->


                <!--====== Blogs Middele columns Start ======-->

                <div class="col-lg-7 order-lg-1 order-1">
                    <div class="main-blog-wrap">
                        <div class="single-blog-item">


                        <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                <img src="../../../assets/images/AI-casestudy-images/banner-image.png"  class=" w-100" alt="blogs banner" />
                        </div>
                            <div class="post-info lg-blog-post-info  wow  blog_moveupsidebar move-up">

                                <div class="post-title global_section_header" role="heading" aria-level="1">Client Story: Protecting Personal Identifiable Information (PII) using AI/ML</div>
                                <div class="post-meta mt-20">
                                    <div class="post-author">
                                      
                                    </div>
                                    <div class="post-date">
                                     <span class="meta-icon"><i class="fa-regular fa-calendar-days"></i></span>
 
                                        Jan, 2024
                                    </div>
                                    <div class="post-view">
                                        <span class="meta-icon"> <i class=" fa-solid fa-eye"></i></span>
                                        450 views
                                    </div>
                                    <div class="post-read">
                                        <span class="meta-icon"> <i class="fa fa-book"></i></span>
                                        3 min Read
                                    </div>
                                    
                                    
                                </div>
                            
                                    <div class="mt-5  data_collection">
                                        <!-- <div class="global_section_header">Choose a fit-for-purpose and cost-effective cloud</div> -->

                                        <p class="pt-2 global_section_content pt-4 ms-4">
                                       <b> Data Collection:</b> The first step is to collect the relevant data that needs to be redacted. This may include documents, emails, databases, or any other sources containing sensitive information.   </p>

                                        <p class="pt-2 global_section_content pt-4 ms-4">
                                        <b> Text Extraction:</b> Once the data is collected, the next step is to extract the text from the different sources. This can involve converting documents into machine-readable formats or extracting text from structured databases.</p>
                                    </div>
                               


                                    <div class="mt-5  data_collection ">

                                    <p class="pt-2 global_section_content pt-4 ">
                                    <b>Processing:</b> The extracted text is then processed using various techniques to identify and redact sensitive information. Custom Regular Expression (REGEX) patterns can be used to search for specific patterns or formats of sensitive data like social security numbers or credit card numbers. Named Entity Recognition (NER) algorithms can identify entities like names, addresses, or medical terms. Rule-based logic and deny lists can be applied to identify and redact specific keywords or phrases. </p>

                                    <p class="pt-2 global_section_content pt-4 ">
                                    <b>Algorithm (BERT, Fine-tune BERT):</b> Advanced algorithms like Bidirectional Encoder Representations from Transformers (BERT) can be utilized for more complex redaction tasks. BERT-based models can be fine-tuned on specific datasets to improve the accuracy and effectiveness of redaction, especially in cases where context and semantics play a crucial role.</p>

                                    <p class="pt-2 global_section_content pt-4 ">
                                    <b>Output:</b> The final step is to generate the redacted output. This can be in the form of updated documents, databases, or reports where the sensitive information has been replaced or masked. The output should ensure that the redacted data is effectively removed or obfuscated, while maintaining the integrity and structure of the original information. </p>

                                    </div>

                                    <div class="mt-5  data_collection">
                                        <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                            <img src="../../../assets\images\blogs\pii-blog22.png" class="img-fluid" style="width: 100%; height: auto !important"  alt="blogs pii-blog2" />
                                            <p class="pt-2 global_section_content pt-4">
                                                When it comes to redacting images, we use an advanced AI/ML technology to detect text lists within the image. Our solution then creates a bounding box directly on the pixel data, runs it through our algorithm, and produces a masked image as the result.</p>
                                        </div>


                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header" style="line-height: 50px;">Examples </div>
                                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                                <img src="../../../assets\images\blogs\pii-blog2.png" class="img-fluid" style="width: 100%; height: auto !important"  alt="blogs pii-blog2" />
                                            </div>
                                        </div>

                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header">Text Redaction </div>
                                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                                <img src="../../../assets\images\blogs\pii-blog3.png" class="img-fluid" style="width: 100%; height: auto !important" alt="blogs pii-blog3" />
                                            </div>
                                        </div>

                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header">Image Redaction </div>
                                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                                <img src="../../../assets\images\blogs\pii-blog4.png" class="img-fluid" style="width: 100%; height: auto !important" alt="blogs pii-blog4" />
                                            </div>
                                        </div>

                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header">Entity extraction </div>
                                            <p class="pt-2 global_section_content pt-4">
                                            We leveraged  NER algorithms to identify and extract named entities, such as people, organizations, and locations, from the text data. It can be used for fraud detection and trend analysis.  </p>                          
                                        </div>

                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header" style="line-height: 50px;">Build your AI/ML solution with us </div>

                                            <p class="pt-2 global_section_content pt-4">
                                            Data redaction is one of the most prominent, one-in-a-thousand applications of AI/ML, and the possibilities are virtually limitless. According to a McKinsey report, over 50% of companies have already incorporated AI into at least one business function, with momentum continuing to soar.</p>
                                            <p class="pt-2 global_section_content pt-4">
                                            Do you have an AI/ML idea that's been brewing in your mind?   Whether it's optimizing your business processes, enhancing customer experiences, or revolutionizing your industry, our experts are here to collaborate with you every step of the way. Together, we'll explore the untapped potential of AI/ML and turn your idea into reality. </p>                          
                                        </div>


                                        <div class="mt-5  data_collection">
                                            <p class="pt-2 global_section_content pt-4">
                                            Team up with our AI/ML experts to push the boundaries of innovation. Talk to us. </p>
                                        </div>
                                    </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--====== Blogs Middele columns End ======-->

        </div>
    </div>
</div>
</div>
</div>


<div class="container-fluid hider">
    <div class="post-title global_section_header mx-5 text-center" role="heading" >AI/ML Use Case: Real-Time Facial Expression Recognition and Annotation</div>
    <div class="post-meta mt-20" style="display: flex; justify-content: center;">
        <div class="post-date">
            <span class="meta-icon"><i class="fa-regular fa-calendar-days"></i></span>
                April, 2024
        </div>
        <div class="post-view view-item1">
            <span class="meta-icon"> <i class=" fa-solid fa-eye"></i></span>
              310 views
        </div>
        <div class="post-read view-item2">
          <i class="fa fa-book"></i>
            3 min Read 
        </div>                        
      </div>

                                <div class="post-feature blog-thumbnail mb-3  wow blog_moveupsidebar move-up">
                                <img src="../../../assets/images/AI-casestudy-images/banner-image.png" class="img-fluid" style="width: 100%; height: auto !important" alt="blogs pii-banner" />
                            </div>

<div class="row">
    <div class="col-md-5 ">
    <div class="tab m-3">
      <!-- Content for the first column -->
      <!-- <p class="tile m-2">Table of Contents</p> -->
      <h3 class="pt-3"  style="color: #A348E8; font-size:20px;"> Table of Contents</h3>
      <hr>

      <li class="tick" style="list-style-type: none; "><a  (click)="scrollToSection('solution')"> Requirements</a></li>
      <hr>

      <li class="tick" style="list-style-type: none; "><a  (click)="scrollToSection('process')">The Approach</a></li>

      <hr>
      <li class="tick" style="list-style-type: none; "><a  (click)="scrollToSection('realTimeApp')"> Real-time Use Cases of FER Application  </a></li>

      <hr>
      <li class="tick" style="list-style-type: none; "><a  (click)="scrollToSection('boundaries')"> Pushing the boundaries of AI/ML Intelligence</a></li>

      <!-- <hr>
      <li class="tick" style="list-style-type: none; " ><a href="#get started"> Get Started</a></li> -->

      <div class="tabss">
        <div class="sidebar-widget blog_sidebarwidget  widgeglobal_section_contentt-blog-recent-post blog_widgetpost wow blog_moveupsidebar move-up ms-4">
            <div class="blog_posttilte sidebar-widget-title global_section_header" role="heading">Recent Posts</div>
                <ul class="blog_ulpost">
                    <li class="blog_lipost">
                        <a href="/postpandamic" class="blog_listanchortags global_section_content">The new wave of Digital Marketing in the Post-Pandemic world</a>
                    </li>
                    <li class="blog_lipost">
                        <a href="/migrate-cloud" class="blog_listanchortags global_section_content">Why is cloud migration critical in the covid-19 scenario</a>
                    </li>
                    <li class="blog_lipost">
                        <a href="/h1b-visa" class="blog_listanchortags global_section_content">What is H1-B Visa</a>
                    </li>
                    <li class="blog_lipost">
                        <a href="/digital-partner" class="blog_listanchortags global_section_content">How to choose your digital partner?</a>
                    </li>
                    <li class="blog_lipost">
                        <a href="/cloud-cost-optimization" class="blog_listanchortags global_section_content">Cloud optimization strategies that drove 50% cost savings</a>
                    </li>
                </ul>
        </div>
      </div>
    </div>
    </div>

 <div class="col-md-7">
    <div class="blogs_subparacontent blog_content text-black">
    <div>
        <p class="global_section_content pt-4">One of the most universal ways that people communicate is through facial expressions. And what if technology could decode your expressions and offer you personalized recommendations based on your mood?</p>
        <p class="global_section_content pt-4">Prepare to be amazed by Facial Expression Recognition and Annotation (FERA), a groundbreaking AI/ML application that not only recognizes and contextualizes  human emotions but also paves the way for innovative applications in industries relying on human-computer interaction - from business intelligence to real time scenarios.</p>
        <p class="global_section_content pt-4">Jack & Jones in Shenzhen, China have utilized FERA technology to interpret emotions, providing users personalized recommendations tailored to their mood. Disney movie have also utilized  the emotion-decoding technology by evaluating the reactions of volunteers to their Star Wars films - creating an immersive and captivating experience.It doesn't stop there. Marketing firms are utilizing emotion detection to measure how audiences response to advertisements. For example, iconic brands like Coca-Cola and Intel, have leveraged the audience response  to fine-tune their marketing strategies and create impactful campaigns- delivering 90 percentage accuracy in their marketing initiatives.</p>
        <p class="global_section_content pt-4">At Maganti IT, we've devised an ingenious AI/ML use case that takes facial expression analysis to the next level. Our team has developed a sophisticated deep convolutional neural network model, trained on a meticulously curated dataset of human facial images. With this AI/ML intelligence, we automated the process of determining emotions in real-time, by analyzing the various features of a face such as eyebrows, eyes, mouth, and other features, and mapping them to a set of emotions such as anger, fear, surprise, sadness and happiness. We've utilized  faces in real-time video streams, analyzed facial expressions, and generated output with annotations based on the individual's emotional state - facilitating successful human- computer interaction.</p>
        <div class="mt-5" id="solution" >
        <div class="global_section_header" role="heading">Requirements</div>
            <p class="global_section_content pt-4">The use case required a Python environment setup, a diverse dataset of human facial images, a face recognition library for accurate detection of face, and the installation of essential libraries such as TensorFlow, Keras, OpenCV, Numpy, and Optuna for model development. Additionally, a camera or video feed served as the input source for real-time application. </p>
        </div>
    </div>
    <div class="mt-5" id="process">
        <div class="global_section_header" role="heading"> The Approach </div>
            <div class="container">
                <div class="row">
                    <div *ngFor="let item of imageItems1" class="col-md-3">
                        <div class="image-item">
                          <img [src]="item.src" class="w-100" alt="Magnifying glass emojis"/>
                          <div class="image-overlay" (click)="showEnlargedImage(item.src)">
                            <span class="search-icon"><img draggable="false" role="img" class="emoji" alt="🔍" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f50d.svg"></span>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="enlargedContainer" *ngIf="isEnlargedVisible" class="enlarged-container">
                <div class="row enlargedrow">
                  <img id="enlargedImage" [src]="enlargedImageSrc" alt="Enlarged Image" />
                  <span id="backButton" class="back-button text-danger" (click)="hideEnlargedImage()">&#8592;</span>
                 
                </div>                    
    </div>
                               
    <div class="mt-5">

        <p class="pt-2 global_section_content pt-4">
        <b>Data Collection:</b> Our journey began with the meticulous collection of human facial images from various sources. These images were carefully segregated based on eight distinct expressions: Anger, Contempt, Disgust, Fear, Happy, Neutral, Sad, and Surprise.</p>

        <p class="pt-2 global_section_content pt-4">
        <b>Data Preprocessing:</b>To enhance the quality of our dataset, we applied suitable filters to the collected images. Leveraging the face recognition library, we extracted human faces and resized the images to meet specific target size requirements. The final step involved converting these cropped images into pixel values using OpenCV. </p>
    </div>
                             
    <div class="mt-5">
        <p class="pt-2 global_section_content pt-4">
        <b>Model Building:</b> Our use case is mainly based on the development of a deep convolutional neural network. To this effect, we designed a facial emotion detection model using TensorFlow with Keras that employs a primitive CNN architecture. The tuning of the model entailed adjusting the weights by using ReLU as an activation function and configuring layers with multiple neurons. The output layer was SoftMax activated to classify and predict emotions into eight classes.</p>

        <p class="pt-2 global_section_content pt-4">
        <b>Model Validation:</b>Ensuring the reliability of our model was paramount. We subjected it to a rigorous evaluation using preprocessed, unseen images. This validation step aimed to estimate the bias by providing crucial insights in the model's performance.</p>

        <p class="pt-2 global_section_content pt-4">
        <b>Real-Time Facial Expression Recognition:</b> The culmination of our efforts was the real-time testing of the model. By capturing facial images from a live video feed, we successfully recognized and annotated facial expressions. The predictions were then displayed on the screen, showcasing the model's ability to respond in real-world scenarios.</p>

        <p class="pt-2 global_section_content pt-4">
        This case study underscores the potential of artificial intelligence to comprehend and respond to human emotions in real-time, paving the way for innovative applications in industries relying on human-computer interaction.</p>
    </div>

    <div class="global_section_header" id="realTimeApp" role="heading"> Real-time Use Cases of FER Application </div>
    <div class="mt-5">
        <p class="pt-2 global_section_content pt-4">
        Facial expression serves as a significant means for humans to convey emotions and can be utilized to identify and ascertain an individual's emotional states. The analysis of facial behavior has found applications across various domains, contributing to the enhancement of human-computer interaction.</p>

        <div class="container">
                <div class="row">
                    <div *ngFor="let item of imageItems2" class="col-md-3">
                        <div class="image-item">
                          <img [src]="item.src" class="w-100" alt="Magnifying glass emoji" />
                          <div class="image-overlay" (click)="showEnlargedImage(item.src)">
                            <span class="search-icon"><img draggable="false" role="img" class="emoji" alt="🔍" src="https://s.w.org/images/core/emoji/14.0.0/svg/1f50d.svg"></span>
                          </div>
                        </div>
                    </div>
                </div>
                <div id="enlargedContainer" *ngIf="isEnlargedVisible" class="enlarged-container">
                    <div class="row enlargedrow">
                      <img id="enlargedImage" [src]="enlargedImageSrc" alt="Enlarged Image" />
                      <span id="backButton" class="back-button" (click)="hideEnlargedImage()">&#8592;</span>
                      
                    </div>                        
        </div>    
                </div>
            </div>

        <p class="pt-2 global_section_content pt-4">
        <b> Intelligent Monitoring:</b> Facial expressions of students in a classroom can be detected to analyze and judge their emotional states. This is valuable for assessing concentration and mental state. </p>

        <p class="pt-2 global_section_content pt-4">
        <b> Accurate Marketing in Supermarkets:</b>Supermarkets can leverage Facial Expression Recognition (FER) to analyze customers' facial expressions, aiding in judging their preferences and assessing how much they like products.</p>

        <p class="pt-2 global_section_content pt-4">
        <b> Telemedicine:</b> Through the analysis of facial expressions, a facial expression analysis system in doctor-patient communication can enable doctors to identify changes in patients’ mental states, thereby assisting them in planning better treatments.  Therefore, Facial Expression Recognition (FER) can play an important role in improving doctor-patient communication and treatment planning by analyzing facial expressions.</p>

        <p class="pt-2 global_section_content pt-4">
        <b> Driving Fatigue Detection:</b>By utilizing facial expression analysis, identifying the driver's state becomes possible, enabling timely warnings and reducing fatigue in driving. An example scenario involves enhancing traffic safety through the detection of driver fatigue.</p>
        <div class="mt-5">
            <div class="global_section_header" id="boundaries" role="heading">Pushing the boundaries of AI/ML Intelligence</div>
                <p class="pt-2 global_section_content pt-4">Maganti IT offers a versatile range of AI consulting services tailored to meet the unique requirements of our clients. The extent of our services is contingent upon factors such as our customers' business needs, the maturity of their data management practices, and the current AI environment. In our AI consulting, we introduce a customized launch strategy, design the optimal architecture and tech stack for your AI solution. Our expertise extends to providing advice on AI security and compliance, along with delivering a detailed project plan for a risk-free AI implementation.</p>
                <p class="pt-2 global_section_content pt-4">Whether integrating AI into existing apps or developing AI-powered software from scratch, our seasoned AI developers possess the skills to deliver industry-specific solutions of any type and complexity at scale. Additionally, our data scientists excel in AI model training, achieving over 95% output accuracy through the creation of representative training datasets, optimization of hyperparameters, and preventing under- and overfitting. Furthermore, we conduct AI audits and revamps, identifying operational issues in your AI solution and providing pragmatic solutions for software upgrades and model enhancements, enabling you to extract higher value from your existing AI infrastructure. Have an AI/ML requirement for your business? Talk to our data experts.</p>
        </div>
    </div>
    </div>
</div>
</div>






